export const fileUploadTypes = {
  ICON: 'icon',
  ZIP_FILE: 'zipFile',
  SIZE: 'size'
};

export const infoModalValues = {
  INFO_MODAL: 'infoModal',
  SHOW: 'show'
};

export const embedUrlRegex =
  /^(https?:\/\/)?(www\.)?youtube\.com\/embed\/[A-Za-z0-9_-]{11}/;
export const youtubeRegex =
  /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)(.{0,500})$/;
export const PUBLIC_APP = 'PUBLIC';
export const CUSTOM_APP = 'CUSTOM';
export const defaultValues = {
  appName: '',
  appLabel: '',
  shortDescription: '',
  appOverView: '',
  appInstructions: '',
  videoUrl: '',
  supportEmail: '',
  supportUrl: '',
  websiteLink: '',
  icon: {},
  zipFile: {}
};

export const appTypeConstants = {
  CUSTOM: 'CUSTOM',
  DRAFT: 'DRAFT',
  PUBLIC: 'PUBLIC',
  DEAL: 'DEAL',
  PRIVATE: 'PRIVATE',
  PUBLISHED: 'PUBLISHED',
  DEVELOPMENT: 'DEVELOPMENT'
};
